<script lang="ts" setup>
</script>

<template>
  <svg
    width="246"
    height="27"
    viewBox="0 0 246 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="238"
      cy="13"
      r="8"
      fill="#D7D8DB"
    />
    <rect
      x="4"
      y="12"
      width="231"
      height="2"
      fill="#D7D8DB"
    />
    <rect
      x="14"
      y="12"
      width="145"
      height="2"
      fill="#7B90FF"
    />
    <circle
      cx="160"
      cy="14"
      r="13"
      fill="#7B90FF"
    />
    <circle
      cx="159"
      cy="13"
      r="12.5"
      fill="#FAFAFB"
      stroke="#7B90FF"
    />
    <circle
      cx="159"
      cy="13"
      r="5"
      fill="#7B90FF"
    />
    <circle
      cx="8"
      cy="13"
      r="8"
      fill="#7B90FF"
    />
    <path
      d="M5 12.6552L7.22857 15L11 11"
      stroke="white"
      stroke-width="2"
    />
    <circle
      cx="81"
      cy="13"
      r="8"
      fill="#7B90FF"
    />
    <path
      d="M78 12.6552L80.2286 15L84 11"
      stroke="white"
      stroke-width="2"
    />
  </svg>
</template>
